import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import ErrorBoundry from "./ErrorBoundry";

import { post } from "../../actions/general";
import { IStateTree } from "../../store/interfaces";
import { IUser } from "../../store/user/models";

const mapStateToProps = ({ user }: IStateTree) => ({ user: user as IUser });

const mapDispatchToProps = { post };

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ErrorBoundry));
